export const initialAbility = [
  {
    action: 'actAs',
    subject: 'user',
  },
]

export const _ = undefined
